/** Zone-neutral yard catalog. Entries retain their original ids and frames. */
export const YARD_PROP_TEMPLATES = {
  // Yard dressing (src/shared/assets/hushHideout/{rowboat,shrine,signpost,firewood,washline,beehives}.ts).
  hush_rowboat: { kind: 'fallen_log', name: 'Beached rowboat', frame: { w: 140, h: 60 }, band: 'architecture' },
  wayside_shrine: { kind: 'sign', name: 'Mossy wayside shrine', frame: { w: 70, h: 110 }, band: 'architecture' },
  hush_signpost: { kind: 'sign', name: 'Leaning crossroads signpost', frame: { w: 80, h: 130 }, band: 'architecture' },
  firewood_pile: { kind: 'fallen_log', name: 'Stacked firewood', frame: { w: 120, h: 70 }, band: 'vegetation' },
  washing_line: { kind: 'sign', name: 'Washing line', frame: { w: 180, h: 110 }, band: 'architecture' },
  beehive_stand: { kind: 'sign', name: 'Straw skeps on a bench', frame: { w: 130, h: 80 }, band: 'architecture' },
} as const;
